import { OfferService } from './../../service/offers/offer.service';
import { FileUpload } from './../../service/FileUpload/fileUpload';
import { FileUploadService } from './../../file-upload.service';
import { LoginService } from './../../service/login.service';

import { AngularFireStorage } from '@angular/fire/storage';
import { MatButtonModule } from '@angular/material/button';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
@Component({
  selector: 'app-edit-offer',
  templateUrl: './edit-offer.component.html',
  styleUrls: ['./edit-offer.component.scss']
})
export class EditOfferComponent implements OnInit {
  members:any;
  addForm:any;
  image="https://i.ibb.co/4774fvj/profileimg.png";
  msg1:string;currentUpload:any;
msg="enter valid";
delete1:boolean=false;

allSelected = false;
allSelected1 = false;

@ViewChild('mySel') skillSel: MatSelect;
@ViewChild('mySel1') skillSel1: MatSelect;

selectedFile:File=null;UserProfilePath:string='USERS';
all:boolean=false;
credit:any="Credit";
debit:any="Debit";
upi:any="UPI";
id:any;terms:any;
    constructor(private route:Router,private activeRoute:ActivatedRoute, private ApiService:OfferService, private fb:FormBuilder,private UploadService:FileUploadService) {
      this.addForm={
        status:true,
        image:{url:""},
        Offer_type :"percentage",
        terms:[]
      }
this.id=this.activeRoute.snapshot.paramMap.get('id')
console.log(this.id)
this.getOfferDetail()
     }
     

  ngOnInit(): void {
  }
  getOfferDetail()
  {
    this.ApiService.getOfferDetail(this.id).then((res)=>
    {
      this.addForm=res
    })
  }
  toggleAllSelection() {
    this.allSelected = !this.allSelected;  // to control select-unselect
    
    if (this.allSelected) {
      this.all=true;
      this.skillSel.options.forEach( (item : MatOption) => item.select());
    }
     else {
       this.all=false;
      this.skillSel.options.forEach( (item : MatOption) => {item.deselect()});
    }
    this.skillSel.close();
  }
  toggleAllSelection1() {
    this.allSelected1 = !this.allSelected1;  // to control select-unselect
    
    if (this.allSelected1) {
      this.skillSel1.options.forEach( (item : MatOption) => item.select());
    this.addForm.paymentOption[0].remove()

    }
     else {
      this.skillSel1.options.forEach( (item : MatOption) => {item.deselect()});
    }
    this.skillSel1.close();
  }

  addTerms()
  {
    if(this.terms)
    {
      
    this.addForm.terms.push(this.terms)
    this.terms=''
    console.log(this.addForm)
    }
  }
  deleteTerms(list)
  {
    this.addForm.terms.pop(list)
  }

  paymentChange(education1) {
   
   

    console.log(education1);
   this.addForm.paymentOption=education1;
   console.log(this.addForm);
  }
  offerChange(education1) {
   console.log(education1);
   this.addForm.offerCode=education1;
   console.log(this.addForm);
  }
  showPreview(event:any)
  {
    if(event.target.files && event.target.files[0])
    {
      // const reader=new FileReader();
      //   reader.onload=(e:any)=>this.addForm.image.url=e.target.result;
      //   reader.readAsDataURL(event.target.files[0]);
        this.selectedFile=event.target.files[0];
        // console.log(this.selectedFile);
      this.detectFiles();
    }
   
  }
  detectFiles() {
    // this.deletePreviousFile();
    // this.addForm.image={'url':"https://i.ibb.co/4774fvj/profileimg.png"}
    // this.currentUpload=null;
    this.uploadSingle();
  } 
  uploadSingle()
  {
    this.currentUpload = new FileUpload(this.selectedFile);
    console.log(this.currentUpload);
    this.UploadService.pushUpload(this.currentUpload,this.UserProfilePath).then((res) => {
      this.addForm.image = res;
      this.delete1=true
      console.log(this.addForm.image);
      console.log(this.UploadService.uploadPercentage);
    });
  }
  delete()
  {
    this.deletePreviousFile();
    
  }
  deletePreviousFile()
  {
    if(this.addForm.image.name!=undefined)
    {
      this.UploadService.deleteUpload(this.addForm.image,this.UserProfilePath).then((res)=>
      {
        console.log('Previous Image Deleted');
        this.addForm.image={}
this.delete1=false
        this.currentUpload=null;
      })
    }
  }
  EditOffer()
  {
    // if(this.addForm.paymentOption[0]==0)
    // {
    // const index: number = this.addForm.paymentOption.indexOf(0);
    // if (index !== -1) {
    //     this.addForm.paymentOption.splice(index, 1);
    // }}      
   this.ApiService.EditOfferDetail(this.id,this.addForm).then(
      (res)=>
      {
        console.log(res);
        console.log("Offer Is Updated");
        this.route.navigateByUrl('/dashboard/offerManager')
      }
    );

  console.log(this.addForm);
    }
  }